import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {logoutAction} from '../rootAction';

interface DropdownData {
  options: Array<Record<string, any>>;
  selectedOption: string | null;
  selectedOptionLable: string | null;
}

interface DropdownState {
  [dropdownId: string]: DropdownData;
}

const initialState: DropdownState = {
  ['']: {options: [], selectedOption: '', selectedOptionLable: ''},
};

const clientSlice = createSlice({
  name: 'clients',
  initialState,
  reducers: {
    setOptions: (
      state,
      action: PayloadAction<{
        dropdownId: string;
        options: Array<Record<string, any>>;
      }>
    ) => {
      const {dropdownId, options} = action.payload;
      if (!state[dropdownId]) {
        state[dropdownId] = {
          options: [],
          selectedOption: null,
          selectedOptionLable: null,
        };
      }
      state[dropdownId].options = options;
    },
    selectOption: (
      state,
      action: PayloadAction<{
        dropdownId: string;
        selectedOption: string | null;
        selectedOptionLable: string | null;
      }>
    ) => {
      const {dropdownId, selectedOption, selectedOptionLable} = action.payload;
      if (state[dropdownId]) {
        state[dropdownId].selectedOption = selectedOption;
        state[dropdownId].selectedOptionLable = selectedOptionLable;
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logoutAction, () => {
      return initialState;
    });
  },
});

export const {setOptions, selectOption} = clientSlice.actions;
export default clientSlice.reducer;
